import { render, staticRenderFns } from "./Superslot.vue?vue&type=template&id=43e797e7&scoped=true"
import script from "./Superslot.vue?vue&type=script&lang=js"
export * from "./Superslot.vue?vue&type=script&lang=js"
import style0 from "./Superslot.vue?vue&type=style&index=0&id=43e797e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e797e7",
  null
  
)

export default component.exports